// polyfills for IE
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/symbol';
import 'core-js/fn/symbol/iterator';

import React from 'react';
import Select from 'react-select';
var binarySearch = require("binary-search");

class Configurator extends React.Component {
  constructor(props) {
    super();
    this.state = {
      options: [],
      variants: [],
      selected_variant: null,
      selected_options: {}
    };

    var self = this;
    props.app.bind('OPTIONS_LOADED', function(data) {
      self.load(data, this.initialVariants);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onUpdated) {
      this.props.onUpdated();
    }
  }

  load(data, initial_variants = []) {
    // update state to load configurator for this product
    this.setState(data);

    // if we have an initial_variant that matches one of our fetched variants, load it
    for (let i = 0; i < initial_variants.length; i++) {
      let variant = this.state.variants.find(v => v.id === initial_variants[i]);
      if (variant != null) {
        let updated = this.updateVisibility(this.state.options, variant.options);
        this.updateEnabled(updated.options, updated.selection);
        this.setState({
          options: updated.options,
          selected_options: updated.selection,
          selected_variant: variant
        });
        this.onVariantChanged(variant);
        break;
      }
    }

    // if we didn't find an initial variant to set, choose the first option
    if (this.state.selected_variant == null && this.state.options.length > 0 && this.state.options[0].values.length > 0) {
      this.handleGroupChange(this.state.options[0], this.state.options[0].values[0]);
    }

    // TODO: if there wasn't a matching initial_variant or there weren't enough options/values to set an initial value, what should we do?
  }

  isEquivalent(a, b) {
    // http://adripofjavascript.com/blog/drips/object-equality-in-javascript.html
    // works for our needs
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    if (aProps.length != bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
  }

  // Where a and b are objects containing properties for OptionGroupId = OptionId
  // e.g. { 1: 10 } where 1 is OptionGroup "RAM" and 10 is Option "8GB"
  compareOptions(a, b, excluding=null) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    var total = Math.max(aProps.length, bProps.length);
    let accum = 0;

    // loop while both lists haven't been exhausted
    for (let i = 0; i < total && i < aProps.length && i < bProps.length; i++) {
      let propName = aProps[i];
      // intentionally check equality, not equivalence
      if (propName != excluding && propName in a && propName in b && a[propName] == b[propName])
        accum++;
    }

    return {
      total: total,
      matching: accum
    };
  }

  // Where a and b are objects containing properties for OptionGroupId = OptionId
  // e.g. { 1: 10 } where 1 is OptionGroup "RAM" and 10 is Option "8GB"
  // if an option group exists in both but the value differs, it will return the value in 'a'.
  optionDifference(a, b, excluding=null, nullWildcard=false) {
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    let differences = {};

    // loop while the first object hasn't been exhausted
    for (let i = 0; i < aProps.length; i++) {
      let propName = aProps[i];
      // intentionally compare with type coercion
      if (propName != excluding && (!(propName in b) || (a[propName] != b[propName]))) {
        // add if:
        // - we're not using null as a wildcard, or
        // - null is a wildcard but neither value is null (i.e. they still differ by a concrete value)
        if (!nullWildcard || (a[propName] !== null && b[propName] !== null)) {
          Object.assign(differences, {[propName]: a[propName]});
        }
      }
    }

    // add any remaining keys in the second object that weren't in the first
    for (let i = 0; i < bProps.length; i++) {
      let propName = bProps[i];
      if (!(propName in a))
        Object.assign(differences, {[propName]: b[propName]});
    }

    return differences;
  }

  /*
    Update all option groups (and associated options) visibility based on the group/option parameter given.

    selection: the object containing the current groupid:optionid that should be selected
    group: the group that changed
    option: the new value for group

    returns: an updated selection if it had to change based on an existing group or option becoming hidden, or null if no change.
   */
  updateVisibility(options, selection) { //, group, option) {

    // create copies of options and selection to maintain immutability principle
    selection = Object.assign({}, selection);
    let groups = [];
    options.forEach((g, gi) => {
      groups.push(Object.assign({
        order: gi
      }, g));  // shallow clone, therefore values will be the original references
    });

    for (let g of groups) {
      if (g.deps === undefined)
        g.deps = this.getVisibilityDependencies(groups, g);
    }

    // now that all dependencies have been resolved, sort into deps order so we can then update visibility
    groups.sort(this.compareDependencies);

    // visibility can now be updated sequentially since it's in dependency order
    for (let g of groups) {
      // if any of the dependencies are not selected, hide
      let visible = true;
      for (let d of Object.getOwnPropertyNames(g.deps)) {
        visible = visible && (selection[d] === g.deps[d]);
      }
      g.visible = visible;

      // update selection based on change in visibility
      // subsequent groups dependent on this group will now use
      // the updated value
      if (g.visible) {
        if (!(g.id in selection))
          selection[g.id] = null;  // wildcard option; previously g.values[0].id;
      } else {
        delete selection[g.id];
      }
    }

    groups.sort((a, b) => {
      return a.order - b.order;
    });

    return {
      options: groups,
      selection: selection
    };
  }

  getVisibilityDependencies(options, group) {
    if (group == null || group.visibility === undefined)
      return {};
    else if (group.deps !== undefined)
      return group.deps;
    else {
      // initialise dependencies with immediate visibility requirements
      let deps = Object.assign({}, group.visibility);

      // loop over each direct dependency and compile further dependencies
      for (let prop of Object.getOwnPropertyNames(group.visibility)) {
        let subdeps = this.getVisibilityDependencies(options, options.find(g => g.id == prop));
        Object.assign(deps, subdeps);
      }

      return deps;
    }
  }

  compareDependencies(a, b) {
    if (b.id in a.deps)
      return 1;
    else //if (a.id in b.deps)
      return -1;
  }

  join(haystack, delimiter = ', ', final = ' and ', toString = String) {
    haystack = haystack.filter(v => v != null && v != '');
    let parts = [];
    for (let i = 0; i < haystack.length; i++) {

      if (i > 0) {
        if (i < haystack.length - 1)
          parts.push(delimiter);
        else
          parts.push(final);
      }

      parts.push(toString(haystack[i]));
    }
    return parts.join('');
  }

  /*
    Takes a selection object which has key:value pairs relating to group.id:value.id that will be used to compare
    similarity to variants.options to sort the variants into order where the nearest match to selection is found.

    differenceFunc(variant) can optionally be provided that returns an object that contains the differences to
    selection, also in group.id:value.id format. Default is this.optionDifference(variant, selection).
   */
  variantDifferenceSortFunc(selection, differenceFunc = null) {
    let self = this;

    // generate an ordered group lookup for sorting
    let orderedGroups = {};
    this.state.options.filter(group => group.id in selection).map((group, gi) => {
      let orderedValues = {};
      group.values.forEach((value, vi) => orderedValues[value.id] = vi);
      orderedGroups[group.id] = orderedValues;
    });

    // default differenceFunc is the class optionDifference func if caller didn't specify it
    if (differenceFunc === null) {
      differenceFunc = function(variant) {
        return self.optionDifference(variant.options, selection, null, true);
      }
    }

    return function(variant1, variant2) {
      // sort by least differences followed by price followed by lowest ordered group/option
      let aDiff = differenceFunc(variant1);
      let bDiff = differenceFunc(variant2);
      let diff = Object.getOwnPropertyNames(aDiff).length - Object.getOwnPropertyNames(bDiff).length;

      if (diff === 0) {
        diff = variant1.rates[0].price - variant2.rates[0].price;
        if (diff === 0) {
          // same number of differences between a and b (but not necessarily the same differences)
          // choose whichever has matching groups in the earliest order
          for (let i = 0; i < self.state.options.length; i++) {
            let group = self.state.options[i];
            if (group.id in variant1.options && group.id in variant2.options && group.id in orderedGroups) {
              // it should be the case that all compared variants will have the same set of groups
              diff = orderedGroups[group.id][variant1.options[group.id]] - orderedGroups[group.id][variant2.options[group.id]];
              if (diff !== 0) {
                // break the group/value loop here if there's a difference
                return diff;
              }
            }
          }
        }
      }
      return diff;
    }
  }

  /*
    Running time: O(n*m + m*p) where n = number of groups, m = total number of option group values, and p = number of variants
   */
  updateEnabled(options, selection) {
    let self = this;

    // loop over each group, filtered to groups in the current selection
    options
      .filter(group => group.id in selection)
      .forEach(group => {
        // loop over each value in that group
        group.values.forEach(value => {
          // use selection with an override for selection[group] = value
          let pseudoSelection = Object.assign({}, selection, {[group.id]: value.id});

          // if there are any options in the current selection that have a dependency on the group we're varying and
          // the value we're using doesn't match that dependency, remove that group from the selection
          // e.g. if we changed condition from new to preloved and the colour group is only visible when condition:new,
          //      then colour should be removed from the selection as it's not relevant for condition:preloved
          options.filter(g => g !== group && g.visibility && group.id in g.visibility && g.visibility[group.id] !== value.id)
            .forEach(g => {
              if (g.id in pseudoSelection) {
                delete pseudoSelection[g.id];
              }
            });

          let variantDiffFunc = function(variant) {
            if (variant.differences === null) {
              variant.differences = self.optionDifference(variant.options, pseudoSelection);
              // drop any differences that aren't in the pseudoSelection. This will only affect results
              // where visibility is required (e.g. if condition group is present, or user defined visibility)
              Object.getOwnPropertyNames(variant.differences).filter(key => !(key in pseudoSelection)).forEach(key => {
                delete variant.differences[key];
              });
            }
            return variant.differences;
          };
          let sortFunc = self.variantDifferenceSortFunc(pseudoSelection, variantDiffFunc);

          // for each variant
          let sorted = [];
          this.state.variants
            .filter(variant => group.id in variant.options && variant.options[group.id] == value.id)
            .forEach(variant => {
              // add copy of variant with differences key to temporary array
              let temp = Object.assign({}, variant, {'differences': null});
              let index = 0;
              if (sorted.length === 0) {
                // if there's only one variant, we still need to run it through our diff func to update the differences property
                variantDiffFunc(temp);
              } else {
                index = binarySearch(sorted, temp, sortFunc);
              }
              index = index < 0 ? ~index : index;
              sorted.splice(index, 0, temp);
            });

          // differences[0] will either be a match (i.e. no differences), which means this option is enabled
          // or it'll contain the least number of other groups that need to change to make this option value enabled
          value.differences = sorted[0].differences || {};
          value.enabled = Object.getOwnPropertyNames(value.differences).length === 0;
          value.remark = value.enabled ? null :
            'Not available with ' + this.join(Array.from(Object.getOwnPropertyNames(value.differences), group_id => {
              // find the group name of the differing option
              let g_ = this.state.options.find(o => o.id == group_id);

              if (group_id in selection) {
                // find the current selected value name for that group
                let v_ = g_.values.find(v => v.id == selection[group_id]);

                // output the group that differs, with the value that is selected so it says "not available with X"
                if (String(v_.value || '').toLowerCase().endsWith(String(g_.name || '').toLowerCase())) {
                  return String(v_.value);
                } else {
                  return `${v_.value} ${g_.name}`;
                }
              }

              return '';
             }));
        });
      });
  }

  findVariant(options) {
    return this.state.variants.find(variant => this.isEquivalent(variant.options, options));
  }

  onVariantChanged(variant) {
    this.props.onVariantChanged(variant.id);
  }

  handleGroupChange(group, option) {
    let self = this;

    // update the selected options visibility based on the change of this option group's value
    let selection = Object.assign({}, this.state.selected_options);
    selection[group.id] = option.id;

    // get all variants that match the desired option group value
    let closestMatches = this.state.variants.filter(variant => {
      return group.id in variant.options && variant.options[group.id] === option.id;
    });

    // sort using our standard variant sorting function so we can determine the closest match
    // including that which would require a change in visibility
    closestMatches.sort(this.variantDifferenceSortFunc(selection));
    selection = Object.assign({}, closestMatches[0].options);

    // now update the visibility of option groups, possibly modifying the selection if visibility rules override the combination
    let updated = this.updateVisibility(this.state.options, selection);

    // now that visibility has been updated, determine the valid combinations of options from this
    // option group's change using the variant data to enable/disable the remaining visible options

    // visibility update will have given us modified groups and selection
    // selection will have a value for every group, but may not match a variant, so adjust values (and enabled state)
    // to ensure we match a variant

    // sort using our standard variant sorting function
    // this might not be necessary assuming the previous sort meant that updateVisibility didn't change anything
    closestMatches.sort(this.variantDifferenceSortFunc(updated.selection));

    // update the selection to match the closest-matching variant options
    Object.assign(updated.selection, closestMatches[0].options);

    // directly update the enabled state of the options given
    this.updateEnabled(updated.options, updated.selection);

    // refresh the state
    this.setState({
      options: updated.options,
      selected_options: updated.selection,
      selected_variant: closestMatches[0]
    });

    this.onVariantChanged(closestMatches[0]);
  }

  renderGroup(group) {
    if (group.visible === false)
      return null;

    let selected = group.values.find(option => this.state.selected_options[group.id] === option.id);
    if (selected === undefined)
      selected = group.values[0];

    // if using swatch styles, ensure all options have a swatch image otherwise fall back to dropdown
    let style = group.style;
    if (style === 'swatch') {
      let valid = true;
      group.values.forEach(v => {
        valid &= (v.swatch != null && v.swatch !== '');
      });
      if (!valid)
        style = 'dropdown';
    }

    return <OptionGroup key={group.id}
                        id={group.id}
                        name={group.name}
                        style={style}
                        inline={group.inline === true}
                        items={group.values}
                        selected={selected}
                        onChange={(option) => this.handleGroupChange(group, option)} />;
  }

  render() {

    // intent: have a top-level div that contains the combination of all visible values within the groups
    // also, have an order dependent style list AT THE END of the class names to ensure we can
    // use the endswith CSS selector [class$="style-dropdown"] to style a variant description correctly in pure CSS
    let visibleGroups = this.state.options.filter(group => group.visible);
    let groupClasses = visibleGroups.map(group => `option-group-${group.id}-${this.state.selected_options[group.id]}`).join(' ');
    let styleClasses = visibleGroups.map(group => `style-${group.style || 'button'}`).join(' ');
    let optionGroupsClass = `option-groups option-groups-${visibleGroups.length} ${groupClasses} ${styleClasses}`;

    //if (this.state.selected_variant.)
    let description = null;
    if (this.state.selected_variant && this.state.selected_variant.html) {
      description = (
        <div className="variant-description" data-pricing={this.state.selected_variant.pricing} dangerouslySetInnerHTML={{__html: this.state.selected_variant.html}} />
      );
    }

    return (
      <div>
        <div className={optionGroupsClass}>
          {this.state.options.map(group => this.renderGroup(group))}
        </div>
        {description}
      </div>
    );
  }
}

class OptionGroup extends React.Component {

  getAriaLabel(option) {
    return `${this.props.name} ${option.value}`;
  }

  slugify(text) {
    // https://gist.github.com/mathewbyrne/1280286
    return String(text).toLowerCase()
      .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
      .replace(/[\s_-]+/g, '-') // swap any length of whitespace, underscore, hyphen characters with a single -
      .replace(/^-+|-+$/g, ''); // remove leading, trailing -
  }

  handleSelectChanged(selected) {
    if (selected != null) {
      let option = this.props.items.find(o => o.id === selected.value);
      if (option != null) {
        this.props.onChange(option);
      }
    }
  }

  renderOptionButton(option) {
    let className = 'btn' + (option === this.props.selected ? ' btn-primary' : ' btn-default')
                          + (option.enabled ? '' : ' disabled');

    let content = option.value;
    if (option.html !== undefined) {
      content = (
        <span dangerouslySetInnerHTML={{__html: option.html}} />
      );
    }

    let extraSettings = {};
    if (option.remark) {
      Object.assign(extraSettings, {
        'data-toggle': 'tooltip',
        'data-placement': 'bottom',
        'data-container': 'body',
        'data-trigger': 'hover',
        'data-html': 'true',
        'data-original-title':`<span class="small"><em>${option.remark}</em></span>`
      });
    }

    return (
      <button key={option.id}
              type="button"
              className={className}
              onClick={() => this.props.onChange(option)}
              aria-label={this.getAriaLabel(option)}
              {...extraSettings}>{content}</button>
    );
  }

  renderOptionSwatch(option, showName=true) {
    let className = 'btn btn-swatch' + (option === this.props.selected ? ' btn-primary' : ' btn-default')
                          + (option.enabled ? '' : ' disabled');
    let title = option.value;
    if (option.remark) {
      title += `<br><span class="small"><em>${option.remark}</em></span>`;
    }

    let nameElement = null;
    if (showName) {
      nameElement = (
        <span className="name">{option.value}</span>
      );
    }

    return (
      <button key={option.id}
              type="button"
              className={className}
              onClick={() => this.props.onChange(option)}
              data-toggle="tooltip" data-placement="bottom" data-container="body" data-trigger="hover" data-html="true"
              data-original-title={title}
              aria-label={this.getAriaLabel(option)}>
        <span className="swatch" style={{backgroundImage: "url('" + option.swatch + "')"}}></span>
        {nameElement}
      </button>
    );
  }

  renderSelectOption(option) {
    let className = '';
    let remarks = null;
    if (!option.model.enabled) {
      className = 'disabled';
    }

    let html = null;
    if (option.model.html) {
      let text = option.model.html.replace(/<[^>]*>?/g, ' ').replace(/\s+/g, ' ').trim();
      let length = text.length;
      if (length > 100)
        text = text.slice(0, text.slice(0, 100).lastIndexOf(' '));
      if (text !== '') {
        html = (
          <div className="html">{text + (length > 100 ? '...' : '')}</div>
        )
      }
    }

    if (option.model.remark) {
      remarks = (
        <div className="remarks">{option.model.remark}</div>
      );
    }

    if (option.model.swatch) {
      className += ' dropdown-swatch';
      return (
        <span className={className}>
          <div className="swatch">
            <img src={option.model.swatch} width="50" height="50" className="img-responsive" />
          </div>
          <div className="text">
            {option.label}
            {html}
            {remarks}
          </div>
        </span>
      );
    }

    return (
      <span className={className}>
        {option.label}
        {html}
        {remarks}
      </span>
    );
  }

  render() {
    let self = this;
    let className = `option-group option-group-${this.props.id}`;
    if (this.props.selected)
      className += ` selected-${this.slugify(this.props.selected.id)}`;
    if (this.props.style !== undefined)
      className += ` style-${this.props.style}`;
    className += this.props.inline ? ' form-horizontal' : '';

    // Reused structure no matter the style of this OptionGroup
    // Can render either stacked or horizontal depending on flag from data
    let wrapperClass = this.props.inline ? 'form-group' : 'row';
    let titleClass = 'title ' + (this.props.inline ? 'col-sm-3 col-xs-12 control-label' : 'col-xs-12');
    let optionClass = 'options ' + (this.props.inline ? 'col-sm-9 col-xs-12' : 'col-xs-12');

    let child = null;
    if (this.props.items.length <= 1) {
      className += ' singleton';
    }

    if (this.props.style === 'dropdown') {
      // Dropdown is rendered using the react-select component which allows customised rendering, disabled states, and a heap more
      // https://github.com/JedWatson/react-select
      let options = this.props.items.map(option => {
        return {
          value: option.id,
          label: option.value,
          model: option
        };
      });

      let settings = {
        clearable: false,
        searchable: false,
        inputProps: {
          'aria-label': this.props.name
        }
      };

      let element = null;
      if (options.length > 1) {
        element = (
          <Select className={optionClass}
                  name={'select-' + this.props.id}
                  value={this.props.selected.id}
                  options={options}
                  onChange={(v) => this.handleSelectChanged(v)}
                  optionRenderer={v => this.renderSelectOption(v)}
                  valueRenderer={v => this.renderSelectOption(v)}
                  {...settings}
          />
        );
      } else if (options.length === 1) {
        element = (
          <div className={"Select Select--single has-value " + optionClass}>
            <div className="Select-control">
                <div className="Select-value">
                  <span className="Select-value-label">
                    {this.renderSelectOption(options[0])}
                  </span>
                </div>
            </div>
          </div>
        );
      }

      child = (
        <div className={wrapperClass}>
          <label className={titleClass}>{this.props.name}:</label>
          {element}
        </div>
      );
    } else {

      let prefix = null;
      let renderOption = null;
      if (this.props.style === 'swatch') {
        let showSwatchName = false; //this.props.items.find(option => String(option.value).length > 10) == null;
        if (!showSwatchName) {
          prefix = (
            <label className={'name' + (this.props.inline ? ' control-label' : '')}>{this.props.selected.value}</label>
          );
        }

        renderOption = function (option) {
          return self.renderOptionSwatch(option, showSwatchName);
        };
      } else {
        renderOption = function (option) {
          return self.renderOptionButton(option);
        };
      }

      child = (
        <div className={wrapperClass}>
          <label className={titleClass}>{this.props.name}: <span className="name">{this.props.selected.value}</span></label>
          <div className={optionClass + ' btn-group'}>
            {prefix}
            {this.props.items.map(option => renderOption(option))}
          </div>
        </div>
      );
    }

    let html = null;
    // if ((this.props.selected.html || '').trim() !== '' && this.props.style === 'dropdown') {
    //   html = (
    //     <div className="html" dangerouslySetInnerHTML={{__html: this.props.selected.html}} />
    //   );
    // }

    return (
      <div className={className}>
        {child}
        {html}
      </div>
    );
  }
}

export {
  Configurator as default
}



// WEBPACK FOOTER //
// ./js/products/configurator.jsx